import React from 'react';
import Header from './Header';
import { useAuth } from '../hooks/useAuth';
import { navigate } from './Router';

const AboutPage: React.FC = () => {
  const { currentUser, loading } = useAuth();

  return (
    <div className="min-h-screen p-4 sm:p-8 bg-theme-primary text-theme-primary">
        <Header />

        <article className="space-y-8">
          <section>
            <h2 className="text-lg fira-sans-bold text-theme-primary mb-3">About this project</h2>
            <div className="flex justify-center my-4">
              <img
                src="/profile.png"
                alt="Takuji Ikeda"
                className="w-32 h-32 rounded-full object-cover border-2 border-theme-primary"
              />
            </div>
            <div className="space-y-4 text-sm leading-relaxed text-theme-secondary">
              <p>
                This is a personal project by <a href="https://x.com/tikeda" target="_blank" rel="noopener noreferrer" className="text-brand-primary hover:text-brand-hover transition-colors">tikeda</a>, where moments from everyday life are reimagined as pixel art with AI.
              </p>
              <p>
                Photos, memories, places, and small events from my daily life are transformed into an alternate visual world — a slightly different version of reality shaped through AI and pixel art.
              </p>
              <p>
                The project is an ongoing experiment in exploring how AI can reinterpret personal memories and everyday experiences.
              </p>
            </div>
          </section>
        </article>

        {/* ホーム画面に追加したアプリは Safari とログイン状態を共有しないため、アプリ内からログインできる導線を置く */}
        {!loading && !currentUser && (
          <footer className="mt-12 text-center">
            <button
              onClick={() => navigate('/px/admin')}
              className="text-xs text-theme-tertiary opacity-60 hover:opacity-100 transition-opacity"
            >
              Sign in
            </button>
          </footer>
        )}
    </div>
  );
};

export default AboutPage;
